import { createSelector } from "reselect";
import { RootState } from "RootReducer";
import { inboundInitialState } from "../../../InboundReducer";

const selectInboundState = (state: RootState) => state.inbound || inboundInitialState;

export const selectAppointmentDetailsMap = createSelector(
  [selectInboundState],
  (inboundState) => inboundState.appointmentDetailsByShipmentId
);

export const selectAppointmentDetailsForShipment = (shipmentId: number | null) =>
  createSelector([selectAppointmentDetailsMap], (map) => (shipmentId ? map[shipmentId] : undefined));
